import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { API_BASE_URL } from "./utils/config";

import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import EULA from "./pages/EULA";
import NotFound from "./components/NotFound";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Goodbye from "./pages/Goodbye";
import LandingNav from "./components/LandingNav";
import Generate from "./pages/Generate";
import Companies from "./pages/Companies";
import Profile from "./pages/Profile";
import LandingPage from "./pages/LandingPage";
import LineItemDetails from "./pages/LineItemDetails";
import ProtectedLayout from "./layouts/ProtectedLayout";
import { AppDataProvider } from "./context/AppDataContext";

function App() {
  const location = useLocation();

  // Fire-and-forget wake call: the database auto-pauses when idle and takes
  // ~15s to resume, so kick off the resume the moment the site loads. By the
  // time the user has logged in / navigated, the DB is already awake.
  useEffect(() => {
    // /wake lives at the API root (next to /health), not under /api/v0
    const apiOrigin = API_BASE_URL.replace(/\/api\/v0$/, "");
    fetch(`${apiOrigin}/wake`).catch(() => {});
  }, []);

  return (
    <AppDataProvider>
      {/* Landing navbar ONLY on landing page */}
      {location.pathname === "/" && <LandingNav />}

      <Routes>
        {/* ---------- PUBLIC ---------- */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/eula" element={<EULA />} />
        <Route path="/goodbye" element={<Goodbye />} />

        {/* ---------- PROTECTED ---------- */}
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/generate" element={<Generate />}>
            <Route path="line-item" element={<LineItemDetails />} />
          </Route>
          <Route path="/line-item" element={<LineItemDetails />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/profile" element={<Profile />} />
        </Route>

        {/* ---------- FALLBACK ---------- */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppDataProvider>
  );
}

export default App;